<script setup>
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import FlowCard from 'dashboard/components-next/aivoice/FlowCard.vue';
import { flowsList } from '../emptyStateContent.js';

const emit = defineEmits(['click']);

const onClick = () => {
  emit('click');
};
</script>

<template>
  <EmptyStateLayout
    :title="$t('AI_VOICE.FLOWS_PAGE.EMPTY_STATE.TITLE')"
    :subtitle="$t('AI_VOICE.FLOWS_PAGE.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <FlowCard
          v-for="flow in flowsList.slice(0, 5)"
          :id="flow.id"
          :key="`flow-${flow.id}`"
          :name="flow.name"
          :description="flow.description"
          :flow-type="flow.flow_type"
          :active="flow.active"
          :created-at="flow.created_at"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('AI_VOICE.FLOWS_PAGE.CREATE_FLOW')"
        icon="i-lucide-plus"
        color="blue"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
